import React, { useEffect, useState, useCallback } from "react";
import get from "lodash/get";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { getApiPath, ADD_UPDATE, VIEW } from "../../api/ApiConst";
import apiCaller from "../../api/ApiCaller";
import Select from 'react-select';
import textUtils from "../common/utilities/TextUtils";

/**
 * Function to create an initial state object for form based on document meta attributes
 * @param {Array} attributes 
 */
const getInitialStateObject = (attributes) => {
    const initialState = {};
    attributes.forEach((attribute) => {
        const fieldName = attribute.value;
        initialState[fieldName] = attribute.defaultValue ?? "";
        if (attribute.type === 'select' && !attribute.dataList) {
            attribute.dataList = attribute.dataListFunction?.() || [];
        }
    });
    return initialState;
};

/**
 * Function to map row data to form state
 * @param {Array} attributes 
 * @param {Object} row 
 */
const mapRowToFormState = (attributes, row) => {
    
    const initialState = {};
    attributes.forEach((attribute) => {
        const fieldName = attribute.value;
        initialState[fieldName] = get(row, fieldName, "");
    });
    return initialState;
};

const DynamicForm = ({
    isModel = false,
    row = null,
    documentMeta
}) => {
    const [addEditModel, setAddEditModel] = useState(() => getInitialStateObject(documentMeta.attributes));


    useEffect(() => {
        const fetchData = async () => {
            const url = new URL(window.location.href);
            const itemId = url.pathname.split('/')[2];
    
            if (row === undefined || row === null) {
                getItemDetail(documentMeta.basePath, itemId);
               
            } else {
                if (row?.id || itemId === undefined) {
                    setAddEditModel(mapRowToFormState(documentMeta.attributes, row));
                } else {
                    setAddEditModel(getInitialStateObject(documentMeta.attributes));
                }
            }
        };
    
        fetchData();
    }, [row, documentMeta.attributes]);
    

    
    const handleSelectChange = (selectedOption, field) => {
        setAddEditModel((prev) => ({
            ...prev,
            [field.value]: selectedOption?.value || ""
        }));
    };

    const handleCheckBoxChange = (checked, field) => {
        setAddEditModel((prev) => ({
            ...prev,
            [field]: checked
        }));
    };

    const handleTextChange = (key, value) => {
        setAddEditModel((prev) => ({
            ...prev,
            [key]: value
        }));
    };

    const handleCreateParameter = () => {
        let requestObj = { ...addEditModel };
        delete requestObj.selectedValue;

        // Remove `id` field if it's empty or not defined
        if (!requestObj.id) {
            delete requestObj.id;
        }

        for (const field in requestObj) {
            if (textUtils.isEmpty(requestObj[field], field, true)) {
                delete requestObj[field];
            }
        }

        const url = getApiPath(documentMeta.basePath, ADD_UPDATE);
        apiCaller.callPostApi(
            url,
            requestObj,
            {},
            (response) => {
                 toast.success(
                    `${documentMeta.label} ${addEditModel?.id ? "Updated" : "Created"} Successfully`
                );
                if(!addEditModel?.id?.length > 0){
                    resetForm();
                }
            },
            (error) => {
                toast.error(error.response?.data?.message || "An error occurred while saving");
            }
        );
    };

    const resetForm = () => {
        setAddEditModel(getInitialStateObject(documentMeta.attributes));
    }

    const getItemDetail =  (basePath,itemId) => {
         let getClient = getApiPath(basePath, VIEW, itemId);
                if (itemId !== 'add-item') {
                     apiCaller.callGetApi(getClient, {}, (response) => {
                        setAddEditModel(mapRowToFormState(documentMeta.attributes, response));
                    }, (error) => {
                        //    console.log(error);
                    });
                }
    }

    return (
        <>
            {documentMeta.attributes.map((field, index) => (
                <div key={index} className="form-group row mb-3">
                    <div className="col-lg-12">
                        {field.formAttribute && <label htmlFor={field.value}>{field.name}</label>}

                        {(field.type === "text" || field.type === "number" ) && field.formAttribute && (
                                <input
                                    type={field.type}
                                    name={field.value}
                                    id={field.value}
                                    className={field.className || "form-control"}
                                    aria-label={field.name}
                                    onChange={(e) => handleTextChange(field.value, e.target.value)}
                                    value={addEditModel[field.value]}
                                />
                            )}
                            
                        {field.type === "select" && (
                            <Select
                                options={field.dataList}
                                value={field?.dataList?.find(option => option.value === addEditModel[field.value])}
                                onChange={(e) => {
                                    if (typeof field.handleSelectChange === "function") {
                                        
                                        field.handleSelectChange(e, field);
                                    } else {
                                        handleSelectChange(e, field);
                                    }
                                }}
                                id={field.value}
                                aria-label={field.name}
                                className="react-select-container"
                            />
                        )}

                        {field.type === "checkbox" && (
                            <input
                                type="checkbox"
                                name={field.value}
                                id={field.value}
                                checked={addEditModel[field.value]}
                                onChange={(e) => handleCheckBoxChange(e.target.checked, field.value)}
                                aria-label={field.name}
                            />
                        )}
                    </div>
                </div>
            ))}
            {!isModel && (
                <Button variant="primary" onClick={handleCreateParameter}>
                    Save Changes
                </Button>
            )}

        </>
    );
};

export default DynamicForm;
